import { Injectable } from '@angular/core';
import { FormArray, FormBuilder, FormControl } from '@angular/forms';
import { List } from 'immutable';
import { extend, isNil } from 'lodash';
import { IMultiSelectOption } from './multi-select-field.interface';

@Injectable()
export class MultiSelectFieldBuilder {
  constructor(private _formBuilder: FormBuilder) {}

  buildSelectAllOption(
    selectAllKey: string,
    values: List<IMultiSelectOption>,
    trackingValue?: string
  ): IMultiSelectOption {
    const block = values.some((option: IMultiSelectOption) => option.block); // block select all if any item is blocked
    const selectAllOption = {
      key: selectAllKey,
      value: -1,
      block: block,
    };

    return !isNil(trackingValue)
      ? extend(selectAllOption, { trackingValue })
      : selectAllOption;
  }

  buildValuesFormArray(values: List<IMultiSelectOption>): FormArray {
    return this._formBuilder.array(
      values
        .map((value: IMultiSelectOption) => this.buildValueFormControl(false))
        .toArray()
    );
  }

  buildValueFormControl(selected: boolean): FormControl {
    return new FormControl(selected);
  }

  buildDropdownValues(
    selectAllOption: IMultiSelectOption,
    selectAllFormControl: FormControl,
    values: List<IMultiSelectOption>,
    valuesFormArray: FormArray
  ): List<List<IMultiSelectOption>> {
    const dropdownValues: List<IMultiSelectOption>[] = [];

    if (selectAllOption) {
      const selectAll = extend({}, selectAllOption, {
        valueControl: selectAllFormControl,
      });

      dropdownValues.push(List([selectAll]));
    }

    const mappedValues: List<IMultiSelectOption> = values
      .map((value: IMultiSelectOption, key: number) => {
        return !value.valueControl
          ? extend({}, value, { valueControl: valuesFormArray.controls[key] })
          : value;
      })
      .toList();

    dropdownValues.push(mappedValues);

    return List(dropdownValues);
  }
}
